import { render, staticRenderFns } from "./TextContainer.vue?vue&type=template&id=2a838e40&"
import script from "./TextContainer.vue?vue&type=script&lang=ts&"
export * from "./TextContainer.vue?vue&type=script&lang=ts&"
import style0 from "./TextContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports